import { ChangeDetectorRef, Component, Injectable, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export interface ModalConfig {
  modalTitle: string;
  dismissButtonLabel?: string;
  closeButtonLabel?: string;
  shouldClose?(): Promise<boolean> | boolean;
  shouldDismiss?(): Promise<boolean> | boolean;
  onClose?(): Promise<boolean> | boolean;
  onDismiss?(): Promise<boolean> | boolean;
  disableCloseButton?(): boolean;
  disableDismissButton?(): boolean;
  hideCloseButton?: boolean;
  hideDismissButton?: boolean;
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false,
})
@Injectable()
export class ModalComponent {
  @ViewChild('modalTpl', { read: TemplateRef, static: true }) private modalTpl!: TemplateRef<any>;
  @Input() modalConfig!: ModalConfig;
  @Input() template!: TemplateRef<any>; // <-- Novo: recebe template do pai
  private modalRef!: NgbModalRef;
  isModalOpen = false;

  constructor(
    private modalService: NgbModal,
    private cd: ChangeDetectorRef
  ) { }

  open(): Promise<any> {
    this.isModalOpen = true;
    this.cd.detectChanges();
    this.modalRef = this.modalService.open(this.modalTpl, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
    });
    return this.modalRef.result.finally(() => {
      this.isModalOpen = false;
      this.cd.detectChanges();
    });
  }

  close(): void {
    this.modalRef.close();
  }

  dismiss(): void {
    this.modalRef.dismiss();
  }
}